import { moveFileToFolder } from '@/api/document.api';

export type MoveDocument = { id: string; name: string };
export type MoveResult = MoveDocument & { success: boolean };

// Reuse the owner-scoped endpoint for every document; one rejection must not hide other results.
export const moveDocuments = async (documents: MoveDocument[], folderId: number | null): Promise<MoveResult[]> => {
  const results: MoveResult[] = [];
  for (const document of documents) {
    try {
      const response = await moveFileToFolder({ documentId: document.id, folderId });
      results.push({ ...document, success: response.data.success === true });
    } catch {
      results.push({ ...document, success: false });
    }
  }
  return results;
};
